import React, { useState, useMemo } from "react";
import Common from "Common";
import arrayMutators from "final-form-arrays";

const { Modal, Grid, Icon, Form } = Common;

const POPUP = "popup";
const MODAL = "modal";

export var valuesArr = [];

const CreatePoll = ({
  openModel,
  renderCreatePollHandle,
  size,
  setFormValues,
}) => {
  const [loading, setLoading] = useState(false);
  const [loadingDelete, setLoadingDelete] = useState(false);

  const agendaFields = useMemo(() => {
    let aFields = [
      {
        id: "poll_title",
        label: "Poll Title",
        initialValue: "",
        disabled: loading || loadingDelete,
        isArrayField: false,
      },
      // {
      //   id: "poll_start_time",
      //   label: "Poll Start Time",
      //   initialValue: "",
      //   disabled: loading || loadingDelete,
      //   isArrayField: false,
      // },
      // {
      //   id: "poll_end_time",
      //   label: "Poll End Time",
      //   initialValue: "",
      //   disabled: loading || loadingDelete,
      //   isArrayField: false,
      // },
      {
        id: "questionArray",
        arrayName: "questions",
        arrayNumber: "first",
        isArrayField: true,
        initialValue: {
          questions: [{ question: "", questionType: "", options: [] }],
        },
        disabled: loading || loadingDelete,
        arrayFields: [
          {
            id: "question",
            label: "Question",
            type: "input",
            isArrayField: false,
          },
          {
            id: "questionType",
            label: "Question Type",
            initialValue: "radio",
            disabled: loading || loadingDelete,
            isArrayField: false,
            type: "select",
            controlProps: {
              placeholder: "select",
              fluid: true,
              options: [
                {
                  key: 1,
                  text: "Radio",
                  value: "radio",
                },
                {
                  key: 2,
                  text: "Checkbox",
                  value: "checkbox",
                },
                {
                  key: 3,
                  text: "Input",
                  value: "input",
                },
              ],
            },
          },
          {
            id: "optionsArray",
            arrayName: "options",
            arrayNumber: "second",
            disabled: loading || loadingDelete,
            isArrayField: true,
            initialValue: { options: [{ option: "" }] },
            arrayFields: [
              {
                id: "option",
                label: "option",
                initialValue: "",
                disabled: loading || loadingDelete,
                isArrayField: false,
                type: "input",
              },
            ],
          },
          {
            id: "add_option_btn",
            arrayName: "options",
            disabled: loading || loadingDelete,
            isArrayField: false,
            type: "button",
            text: "Add Option",
            params: {
              type: "button",
              primary: false,
              loading,
              disabled: loading || loadingDelete,
              unique: "add",
              arrayName: "questions.options",
              push: "option",
            },
          },
        ],
      },
    ];
    return aFields;
  }, []);
  const renderForm = () => {
    const buttons = [
      {
        text: "Add Question",
        params: {
          type: "button",
          primary: true,
          loading,
          disabled: loading || loadingDelete,
          unique: "add",
          arrayName: "questions",
          push: "questions",
        },
      },

      {
        text: "Add Poll",
        params: {
          type: "submit",
          color: "green",
          loading,
          disabled: loading || loadingDelete,
        },
      },
    ];

    return (
      <Form
        mutators={{
          ...arrayMutators,
        }}
        fields={agendaFields}
        buttons={buttons}
        onSubmit={onSubmit}
      />
    );
  };
  const renderHeading = () => {
    return (
      <Grid columns={2}>
        <Grid.Column>Create Poll</Grid.Column>
        <Grid.Column textAlign="right" verticalAlign="middle">
          <Icon link name="close" onClick={() => renderCreatePollHandle()} />
        </Grid.Column>
      </Grid>
    );
  };
  const onSubmit = async (values) => {
    valuesArr.push(values);
    setFormValues(valuesArr);
    renderCreatePollHandle(false);
  };

  const El = (
    <>
      <Modal
        open={openModel}
        onClose={() => renderCreatePollHandle()}
        onOpen={openModel}
        size={size}
      >
        <Modal.Header>{renderHeading()}</Modal.Header>
        <Modal.Content>{renderForm()}</Modal.Content>
      </Modal>
    </>
  );
  return El;
};

CreatePoll.defaultProps = {
  displayIn: POPUP,
  triggerEvents: ["click"],
  size: "large",
  openModel: false,
  maxWidth: "95%",
  // basic: false,
};

CreatePoll.POPUP = POPUP;
CreatePoll.MODAL = MODAL;

export default CreatePoll;
